import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Checkbox } from '../ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const CHECKS = { content_outline: 'Outline of content covered', learning_outcomes: 'Designated learning outcomes', timeframe: 'Timeframe allocated',
  documentary_evidence: 'Documentary evidence (attach a file)' };

// Framework-driven fields: competency-area split, CPD group multiplier, verified-activity checklist.
export const CPDActivityExtras = ({ f, setF, features }) => {
  if (!features.areas.length && !features.checks && !features.groups.length) return null;
  return (
    <div className="rounded-xl border bg-slate-50/60 p-3 space-y-3" data-testid="cpd-f-framework-extras">
      <p className="text-xs text-muted-foreground">Required by {features.names.join(', ') || 'selected frameworks'}</p>
      {features.groups.length > 0 && (
        <div className="max-w-xs"><Label>CPD group (credit multiplier)</Label>
          <Select value={f.credit_group || undefined} onValueChange={(v) => setF((x) => ({ ...x, credit_group: v }))}>
            <SelectTrigger data-testid="cpd-f-credit-group"><SelectValue placeholder="Group-1 (1.0×)" /></SelectTrigger>
            <SelectContent>{[...new Set(features.groups)].map((g) => <SelectItem key={g} value={g}>{g}</SelectItem>)}</SelectContent>
          </Select></div>
      )}
      {features.areas.length > 0 && (
        <div><Label>Competency area hours (attended hours; blank = map from categories)</Label>
          <div className="grid sm:grid-cols-3 gap-2 mt-1">{features.areas.map((a) => (
            <div key={a.code}><span className="text-xs text-muted-foreground" title={a.description}>{a.name}</span>
              <Input type="number" step="0.25" min="0" value={f.area_hours?.[a.code] ?? ''} data-testid={`cpd-f-area-${a.code}`}
                onChange={(e) => setF((x) => ({ ...x, area_hours: { ...x.area_hours, [a.code]: e.target.value } }))} /></div>))}</div></div>
      )}
      {features.checks && f.evidence_type === 'Verifiable' && (
        <div className="space-y-1.5" data-testid="cpd-f-verified-checklist"><Label>Verified activity requirements</Label>
          {Object.entries(CHECKS).map(([k, label]) => (
            <label key={k} className="flex items-center gap-2 text-sm">
              <Checkbox checked={!!f.verification?.[k]} data-testid={`cpd-f-check-${k}`}
                onCheckedChange={(v) => setF((x) => ({ ...x, verification: { ...x.verification, [k]: !!v } }))} /> {label}
            </label>))}
          <p className="text-xs text-muted-foreground">If any item is missing the hours count as unverified for these frameworks.</p>
        </div>
      )}
    </div>
  );
};
